import {stringByPropertyNameHasValidValue, getStringByPropertyName} from './Helpers'
import { VB_CATEGORY_SETTINGS } from '../../CustomElements/elementTypes'

export const shouldShowDescriptionContent = (description, htmlContent) => {
   return stringByPropertyNameHasValidValue(description) || htmlStringIsValid(htmlContent)
}

const READ_HTML_STRING_AS_EMPTY_LENGTH = 11 // Default value content editor
export const htmlStringIsValid = (htmlContent) => {
   return htmlContent && htmlContent.length > READ_HTML_STRING_AS_EMPTY_LENGTH
}

 export const HTML_STRING = "html-string"
 export const TEXT_STRING = "text-string"
 export const checkContentDescriptionType = (htmlContent, text) => {
   if (htmlStringIsValid(htmlContent)) {
      return HTML_STRING
   } else if (stringByPropertyNameHasValidValue(text)) {
      return TEXT_STRING
   }
}